// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__u3Sd5","dragIcon":"SortableItem_dragIcon__hKxT2","disabled":"SortableItem_disabled__qUfZk"};